export default __webpack_public_path__ + "transfix-maps/icons/P2-newWave.021e346022d9eec076dac99d8beb16e0.png";